import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import { Modal, ModalBody, ModalHeader, Button, ButtonToolbar, Row, Col, Input, FormGroup } from 'reactstrap';
import { Form, Field, } from 'react-final-form';
import axios from 'axios'

import {sendFlashMessage} from "@/shared/components/flash";
import {PROGRAM_TYPES, PROGRAM_STATUSES} from "@/shared/options";
import {labelizeNamedData, labelizeNamedRow} from '@/shared/helpers'

import renderSelectField from '@/shared/components/form/Select';
// import US_STATES from "@/shared/json/usstates.json";
//import getStatesByCountry from "@/services/getStatesByCountry";
import getStatesByCountry from '@/services/getStatesByCountry';
import getProgramStatusList from '@/services/program/getProgramStatusList'
import formValidation from "@/shared/validation/program-info";
import { getProgramAction } from '@/redux/actions/programActions';

const COUNTRY_ID = 223;

const prepareForValidation = values => {
    const clean = {state_id: values.state_id?.value}
    // console.log(clean)
    return {...values, ...clean}
}

const ProgramInfo = ({dispatch, organization, isOpen, toggle, data, theme, rtl}) => {
    const [statusOptions, setStatusOptions] = React.useState([])
    const [loading, setLoading] = useState(false)
    const [states, setStates] = useState(null)
    
    //console.log('labelizeNamedRow ',organization);
    useEffect( () => {
        if( organization?.id )
        {
            getStatesByCountry(223)
            .then( result => {
                setStates(labelizeNamedData(result))
            })

            getProgramStatusList( organization.id , data.id)
            .then( list => {
                setStatusOptions(labelizeNamedData(list, ["id", "status"]))
            })
        }
        // alert(COUNTRY_ID);
    }, [organization])
    // console.log(data)
    const onSubmitForm = async (values) => {
        // setLoading(true)
        // alert(values.state.value)
        // console.log(values.address)
        if( !values.address )   {
            values.address = {
                country_id: COUNTRY_ID
            }
        }
        if(values?.state_id?.value) {
            values.address.state_id =  values.state_id.value
        }
        const state_id = values["state_id"];
        const status = values["status"];
        // console.log(status)
        delete values["state_id"];
        
        values.type = values?.type?.value
        values.status_id = values?.status?.value

        const array = [
          'bcc_email_list',
          'cc_email_list',
          'prefix',
          'notification_email_list',
          'address.address',
          'address.address_ext',
          'address.city',
          'address.zip',
          'corporate_entity',
          'external_id',
        ];
        array.forEach(function (item, index) {
          values[item] = values[item] ?? '';
        });

        const savedata  = {...data, ...values}

        delete savedata["status"];
        
        // console.log(savedata)
        // alert(JSON.stringify(savedata))
        // return;
        try {
            const response = await axios.put(`/organization/${data.organization_id}/program/${savedata.id}`, savedata);
            // console.log(response)
            
            setLoading(false)
            // console.log(state_id)
            if( response.status === 200)    {
                dispatch(
                  getProgramAction(
                    data.organization_id, 
                    data.id
                  )
                )
                toggle()
                dispatch(sendFlashMessage('Program has been updated', 'alert-success', 'top'))
            }
        } catch (e) {
            setLoading(false)
            dispatch(sendFlashMessage('Program could not be updated', 'alert-danger', 'top'))
            throw new Error(`API error:${e?.message}`)
        }
        // setTimeout(alert('Allset'), 2000)
    }
    if(!data || !organization) return 'loading...'
    // data = patch4Select(data, 'state')
    // console.log(data)
    if( !data.state_id )    {
        data.state_id = data.address?.state ? {label: data.address.state.name, value: String(data.address.state.id)} : null;
    }
    // const statusSelected = labelizeNamedRow(data?.status, ['id', 'status'])
    return (
    <Modal className={`modal-program manager-program-modal modal-lg ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={toggle}>
        <Form
            onSubmit={onSubmitForm}
            validate={(values) => formValidation.validateForm(prepareForValidation(values))}
            initialValues={{
                name: data.name,
                type: {value:data.type, label: PROGRAM_TYPES.find( ptype => ptype.value === data.type)?.label},
                external_id: data.external_id,
                corporate_entity: data.corporate_entity,
                address: data.address,
                cc_email_list: data.cc_email_list,
                bcc_email_list: data.bcc_email_list,
                sub_program_groups: data.sub_program_groups,
                archive_program: data.archive_program,
                deactivate_account: data.deactivate_account,
                enable_global_search: data.enable_global_search,
                allow_managers_to_change_email: data.allow_managers_to_change_email,
                allow_participants_to_change_email: data.allow_participants_to_change_email,
                prefix: data.prefix,
                public_contact_email: data.public_contact_email,
                status: null,
                state_id: data.state_id
            }}
        >
            {({ handleSubmit, form, submitting, pristine, values }) => (
                <form className="form" onSubmit={handleSubmit}>

                    <ModalHeader tag="div" className="manager-program-modal__header">
                        <div className="manager-program-modal__header-row">
                            <div className="manager-program-modal__header-copy">
                                <h3 className="manager-program-modal__title">General Settings</h3>
                                <p className="manager-program-modal__subtitle">
                                    Update core program details and address settings for {data.name}.
                                </p>
                            </div>
                            <ButtonToolbar className="manager-program-modal__actions">
                                <Button outline color="primary" onClick={toggle}>Close</Button>
                            </ButtonToolbar>
                        </div>  
                    </ModalHeader>
       
                    <ModalBody className="manager-program-modal__body">
                            <section className="manager-program-modal__section">
                                <h5 className="manager-program-modal__section-title">Program Information</h5>
                                <Row className='w100'>
                                    <Col md="6" lg="4" xl="4">

                                        <Field name="name">
                                            {({ input, meta }) => (
                                                <FormGroup>
                                                    <span className="form__form-group-label">Program name</span>
                                                    <Input type="text" placeholder="Program name" {...input} />
                                                    {meta.touched && meta.error && (
                                                    <span className="text-danger">{meta.error}</span>
                                                    )}
                                                </FormGroup>
                                            )}
                                        </Field>
                                        

                                        <Field name="external_id">
                                            {({ input, meta }) => (
                                                <FormGroup>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">External ID</span>
                                                        <Input type="text" placeholder="External ID" {...input} />
                                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                    </div>
                                                </FormGroup>
                                            )}
                                        </Field>

                                        <Field name="type">
                                            {({ input, meta }) => (
                                                <div className="form__form-group">
                                                    <span className="form__form-group-label">Program Type</span>
                                                    <div className="form__form-group-field">
                                                        <div className="form__form-group-row">
                                                            <Field
                                                                name="type"
                                                                component={renderSelectField}
                                                                options={PROGRAM_TYPES}
                                                                style={{width:'100%'}}
                                                            />
                                                            {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Field>
                                    </Col>
                                    <Col md="6" lg="4" xl="4">
                                        <Field name="default_user">
                                            {({ input, meta }) => (
                                                <FormGroup>
                                                    <span className="form__form-group-label">Default user</span>
                                                    <Input type="text" placeholder="Default user" {...input} />
                                                    {meta.touched && meta.error && (
                                                        <span className="text-danger">{meta.error}</span>
                                                    )}
                                                </FormGroup>
                                            )}
                                        </Field>
                                        
                                        <Field name="corporate_entity">
                                            {({ input, meta }) => (
                                                <FormGroup>
                                                    <span className="form__form-group-label">Corporate entity</span>
                                                    <Input type="text" placeholder="Corporate entity" {...input} />
                                                    {meta.touched && meta.error && (
                                                        <span className="text-danger">{meta.error}</span>
                                                    )}
                                                </FormGroup>
                                            )}
                                            </Field>
                                           
                                        <Field name="status">
                                        {({ input, meta }) => (
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Status</span>
                                                <div className="form__form-group-field">
                                                    <div className="form__form-group-row">
                                                        <Field
                                                            name="status"
                                                            component={renderSelectField}
                                                            options={statusOptions}
                                                            style={{width:'100%'}}
                                                        />
                                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        </Field>
                                    </Col>
                                    <Col md="6" lg="4" xl="4">
                                        <Field name="public_contact_email">
                                        {({ input, meta }) => (
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Public contact email</span>
                                                <div className="form__form-group-field">
                                                    <div className="form__form-group-row">
                                                        <Input type="text" {...input} placeholder="Public contact email" />
                                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        </Field>  
                                    </Col>
                                </Row>
                            </section>
                            <section className="manager-program-modal__section">
                                <h5 className="manager-program-modal__section-title">Address Settings</h5>
                                <Row className='w100'>
                                    <Col md="6" lg="4" xl="4">
                                        <Field name="address.address">
                                        {({ input, meta }) => (
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Address</span>
                                                <div className="form__form-group-field">
                                                    <div className="form__form-group-row">
                                                        <Input type="text" {...input} placeholder="Address" />
                                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        </Field>  
                                    </Col>
                                    <Col md="6" lg="4" xl="4">
                                        <Field name="address.address_ext">
                                        {({ input, meta }) => (
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Address line 2</span>
                                                <div className="form__form-group-field">
                                                    <div className="form__form-group-row">
                                                        <Input type="text" {...input} placeholder="Address line 2" />
                                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        </Field>  
                                    </Col>
                                </Row>
                                <Row className='w100'>
                                    <Col md="6" lg="4" xl="4">
                                        <Field name="address.city">
                                        {({ input, meta }) => (
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">City</span>
                                                <div className="form__form-group-field">
                                                    <div className="form__form-group-row">
                                                        <Input type="text" {...input} placeholder="City" />
                                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        </Field>  
                                        </Col>
                                        <Col md="6" lg="4" xl="4">
                                            <Field name="address.zip">
                                            {({ input, meta }) => (
                                                <div className="form__form-group">
                                                    <span className="form__form-group-label">Zip</span>
                                                    <div className="form__form-group-field">
                                                        <div className="form__form-group-row">
                                                            <Input type="text" {...input} placeholder="Zip" />
                                                            {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            </Field>  
                                        </Col>
                                        <Col md="6" lg="4" xl="4">
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">State</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="state_id"
                                                        component={renderSelectField}
                                                        options={states}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                            </section>
                            <div className="manager-program-modal__footer-actions">
                                <Button type="submit" disabled={loading} className="btn btn-primary" color="#ffffff">
                                    Save Changes
                                </Button>
                            </div>
                    </ModalBody>
        </form>
            )}
            </Form>
    </Modal>
    )
}

ProgramInfo.propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired,
    organization: Object.isRequired,
    data: Object.isRequired
};
  
export default (connect((state) => ({
    theme: state.theme,
    rtl: state.rtl,
    organization: state.organization,
    data: state.program
}))(ProgramInfo));
